module.exports = __webpack_public_path__ + "img/xcl.967ba32.png";